import styled, { keyframes } from "styled-components";
import { ContainerProps } from "../types";

const open = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;

const close = keyframes`
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
`;

const handleMarginLeft = (isOpen: boolean, isLoading: boolean) =>
  isOpen && !isLoading ? "68px" : "0";

export const Container = styled.div<ContainerProps>`
  height: ${({ contentHeight, isOpen }) =>
    isOpen ? `${contentHeight}px` : "0"};
  min-height: ${({ isOpen }) => (isOpen ? "80px" : "0")};
  margin: ${({ isLoading }) => (isLoading ? "auto" : "0")};
  padding: ${({ isLoading }) => (isLoading ? "26.75px" : "0")};
  padding-left: ${({ isLoading, isOpen, hasSilk }) =>
    !hasSilk ? "40px" : handleMarginLeft(isOpen, isLoading)};
  overflow: hidden;
  transition: height 0.2s ease-in-out;
`;

export const Content = styled.div<Pick<ContainerProps, "isOpen">>`
  opacity: 0;
  animation-name: ${({ isOpen }) => (isOpen ? open : close)};
  animation-duration: 0.5s;
  animation-timing-function: ease-in;
  animation-delay: 0.2s;
  animation-fill-mode: forwards;
`;
